var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58464 18.125C4.8763 18.125 1.04297 14.2916 1.04297 9.58329C1.04297 4.87496 4.8763 1.04163 9.58464 1.04163C14.293 1.04163 18.1263 4.87496 18.1263 9.58329C18.1263 14.2916 14.293 18.125 9.58464 18.125ZM9.58464 2.29163C5.55964 2.29163 2.29297 5.56663 2.29297 9.58329C2.29297 13.6 5.55964 16.875 9.58464 16.875C13.6096 16.875 16.8763 13.6 16.8763 9.58329C16.8763 5.56663 13.6096 2.29163 9.58464 2.29163Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3326 18.9583C18.1742 18.9583 18.0159 18.9 17.8909 18.775L16.2242 17.1083C15.9826 16.8666 15.9826 16.4666 16.2242 16.225C16.4659 15.9833 16.8659 15.9833 17.1076 16.225L18.7742 17.8916C19.0159 18.1333 19.0159 18.5333 18.7742 18.775C18.6492 18.9 18.4909 18.9583 18.3326 18.9583Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconTable);
export default __webpack_public_path__ + "static/media/search-icon-table.1a148fdcff3813fc8543ca90aa2c95ef.svg";
export { ForwardRef as ReactComponent };